var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWbtc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m16.326 8.036l-.377.375a5.297 5.297 0 0 1 0 7.168l.377.375a5.83 5.83 0 0 0 0-7.927zm-7.92.032a5.345 5.345 0 0 1 7.194 0l.377-.375a5.884 5.884 0 0 0-7.957 0zm-.352 7.515a5.297 5.297 0 0 1 0-7.165l-.377-.375a5.83 5.83 0 0 0 0 7.927zm7.542.346a5.345 5.345 0 0 1-7.195 0l-.376.375a5.883 5.883 0 0 0 7.957 0zm-2.524-5.001c0 .483-.429.643-.857.643h-.643v-1.285h.857a.63.63 0 0 1 .643.642m.377 2.169c0 .526-.592.617-1.02.617h-.857v-1.286h.857c.383 0 1.02.155 1.02.668m.928-2.349c-.075-.783-.663-1.24-1.52-1.32V8.143H12v1.279c-.174 0-.248 0-.425.006V8.143h-.86v1.285H9.429v.857h.48c.163 0 .377 0 .377.34v2.87c0 .005 0 .22-.249.22H9.56l-.131.856h1.285v1.286h.858l-.005-1.286H12v1.286h.857v-1.286c1.12-.067 1.805-.3 1.902-1.344c.08-.84-.318-1.216-.951-1.367c.385-.195.627-.539.57-1.112"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.999 5.701C8.509 5.703 5.682 8.523 5.684 12c.002 3.476 2.833 6.293 6.323 6.291c3.487-.002 6.313-2.818 6.314-6.292C18.317 8.522 15.488 5.702 12 5.7m0 13.13c-3.787 0-6.857-3.06-6.856-6.832c0-3.774 3.071-6.832 6.859-6.831c3.785 0 6.855 3.058 6.855 6.83c-.004 3.772-3.072 6.829-6.858 6.833"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWbtc);
export default __webpack_public_path__ + "static/media/wbtc.07abc795c15808a9bba10c8f731214e7.svg";
export { ForwardRef as ReactComponent };